<template>
  <section class="odm-intro-section">
    <div class="odm-intro-inner">
      <h2 class="odm-intro-title">{{ t('odm.odmIntroduce.title') }}</h2>
      <div class="odm-intro-subtitle">{{ t('odm.odmIntroduce.subtitle') }}</div>
      <img class="odm-intro-img" :src="t('odm.odmIntroduce.introImg')" alt="ODM服务流程图" />
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<style scoped>
.odm-intro-section {
  width: 100%;
  background: #fff;
  padding: 80px 0;
  display: flex;
  justify-content: center;
  background-image: url('../../assets/solution/background.png');
  background-repeat: no-repeat;
}

.odm-intro-inner {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.odm-intro-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: bold;
  color: #222;
  margin-bottom: 10px;
  position: relative;
}

.odm-intro-title::after {
  content: '';
  display: block;
  width: 80px;
  height: 4px;
  background: #ff7f1a;
  margin: 10px auto 0 auto;
}

.odm-intro-subtitle {
  margin: 5px auto 0 auto;
  text-align: center;
  font-size: 1.05rem;
  margin-bottom: 3vw;
}

.odm-intro-img {
  width: 70%;
  height: auto;
  display: block;
  object-fit: contain;
}

/* 大屏幕设备 (1400px 以上) */
@media screen and (min-width: 1400px) {
  .odm-intro-title {
    font-size: 2.4rem;
  }

  .odm-intro-subtitle {
    font-size: 1.4rem;
  }

  .odm-intro-title::after {
    width: 80px;
  }

  .odm-intro-section {
    padding: 80px 0;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .odm-intro-title {
    font-size: 2.2rem;
  }

  .odm-intro-subtitle {
    font-size: 1.2rem;
  }

  .odm-intro-img {
    width: 80%;
  }

  .odm-intro-title::after {
    width: 70px;
  }

  .odm-intro-section {
    padding: 70px 0;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .odm-intro-title {
    font-size: 2rem;
  }

  .odm-intro-subtitle {
    font-size: 1rem;
  }

  .odm-intro-img {
    width: 80%;
  }

  .odm-intro-title::after {
    width: 60px;
  }

  .odm-intro-section {
    padding: 60px 0;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  .odm-intro-title {
    font-size: 1.8rem;
  }

  .odm-intro-subtitle {
    font-size: 0.9rem;
  }

  .odm-intro-img {
    width: 90%;
  }

  .odm-intro-title::after {
    width: 50px;
  }

  .odm-intro-section {
    padding: 50px 0;
  }
}
</style>
